import { EMPTY_REVENUE_RECONCILIATION_REPORT_MODEL } from "presentation/model/RevenueReconciliationReport/RevenueReconciliationReportModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: RevenueReconciliationReportProvider,
    useTracked: useRevenueReconciliationReportTracked
} = createContainer(() => useState(EMPTY_REVENUE_RECONCILIATION_REPORT_MODEL), {concurrentMode: true});
export { RevenueReconciliationReportProvider, useRevenueReconciliationReportTracked };
